import { Box, Breadcrumbs, Typography } from "@mui/material";
import { AppColors } from "resources/AppColors";

function BreadCrumbs({ name, icon, ...other }) {
  return (
    <Box
      role="presentation"
      mb={1}
      {...other}
    >
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          variant="body"
          sx={{ display: 'flex', alignItems: 'center' }}
          color={AppColors.PRIMARY}
        >
          {icon}
          {name}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
}

export default BreadCrumbs